import React from "react";

const requestToSellFaq = [
  {
    title: "The USD estimate doesn’t match the market price right now",
    description: (
      <p>
        We use a third party provider in order to get an estimate for the share
        value in USD. The estimation is only updated once every day.
      </p>
    ),
  },
  {
    title: "Who is holding my shares? Which broker?",
    description: (
      <p>
        BF is using the company BF GLOBAL IB MU, a BF Securities Broker
        regulated in Mauritius. BF GLOBAL IB MU is regulated by the Mauritius
        Financial Services Commission (FSC) as a Full Service Dealer, Excluding
        Underwriting. This entity will allow you to custody, buy & sell and
        Trade Public Shares and hold a USD balance for share trading under
        custody.
      </p>
    ),
  },
  {
    title: "How much Fees will I pay to execute a sale trade?",
    description: (
      <p>
        As stated in the Fee Schedule:{" "}
        <a
          style={{ textDecoration: "underline" }}
          href="https://bnktothefuture.com/fees"
          target="_blank"
        >
          https://app.bnktothefuture.com/fees
        </a>
        . The fees charged are $200 flat fee per trade and any fractional fees
        (in kind) if I decide to sell 100% of the shares I have.
      </p>
    ),
  },
];

export default requestToSellFaq;
